import revive_payload_client_4sVQNw7RlN from "/app/ib-rewards/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/ib-rewards/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/ib-rewards/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/ib-rewards/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/ib-rewards/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/ib-rewards/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/ib-rewards/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/app/ib-rewards/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import route_locale_detect_VrpP1JaYg8 from "/app/ib-rewards/node_modules/@nuxtjs/i18n/dist/runtime/plugins/route-locale-detect.js";
import i18n_sq1MuCrqbC from "/app/ib-rewards/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_vue3_YdLad5Mpq3 from "/app/ib-rewards/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/app/ib-rewards/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/ib-rewards/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import analytics_client_mZYnNRQBH8 from "/app/ib-rewards/plugins/analytics.client.js";
import initial_data_lKRJEMtQLN from "/app/ib-rewards/plugins/initial-data.js";
import typograph_5DxQj8Q51f from "/app/ib-rewards/plugins/typograph.js";
import ssg_detect_3fHkBxLtv0 from "/app/ib-rewards/node_modules/@nuxtjs/i18n/dist/runtime/plugins/ssg-detect.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  switch_locale_path_ssr_5csfIgkrBP,
  route_locale_detect_VrpP1JaYg8,
  i18n_sq1MuCrqbC,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  analytics_client_mZYnNRQBH8,
  initial_data_lKRJEMtQLN,
  typograph_5DxQj8Q51f,
  ssg_detect_3fHkBxLtv0
]